import React from "react";
import { Icon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Typography from '@mui/material/Typography';
import { FormattedMessage } from "react-intl";

import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  pageTitle: {
    color: theme.palette.component.productBoxColor,
    fontWeight: 600,
    fontSize: 16,
    marginTop: 0,
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      textAlign: "center",
    },
  },
  pageSubTitle: {
    color: theme.palette.component.productBoxColor,
    fontWeight: 400,
    fontSize: 16,
    marginTop: 0,
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      textAlign: "center",
    },
  },
  cartIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 24,
    marginRight: 15,
    verticalAlign: "middle",
  },
}));
const PageTitle = ({ page }) => {
  const classes = useStyles();
  const subTitleId = page === 2 ? "cart.deliveryInfo" : "cart.products";

  return (
    <h5 className={classes.pageTitle}>
      <Icon className={clsx(["nc-icon nc-cart-simple", classes.cartIcon])} />
      <FormattedMessage id="cart.pageTitle" />
      {" "}
      <Typography component="span" className={classes.pageSubTitle}>
        |{" "}
        <FormattedMessage id={subTitleId} />
      </Typography>
    </h5>
  );
};

export default PageTitle;
